import { Icon } from '@sorrem-client/ui/components';
import classnames from 'classnames';
import type { CrucibleTrait, CrucibleTraitTone } from '../../crucible-traits';
import styles from './CrucibleTraitBadge.module.scss';

interface CrucibleTraitBadgeProps {
    trait: CrucibleTrait;
    /** Shows the trait's label and description on hover; off where they're already written out beside it. */
    hasTooltip?: boolean;
    className?: string;
}

/** Each tone's class; a new tone must have one. */
const TONE_CLASSES: Record<CrucibleTraitTone, string | undefined> = {
    danger: styles.danger,
    warning: styles.warning,
    veil: styles.veil,
    safe: styles.safe,
    neutral: styles.neutral,
};

/** A crucible trait's icon, large and in its tone, on a faded dark tile, with its count (if any) in the corner. */
export function CrucibleTraitBadge({ trait, hasTooltip = true, className }: CrucibleTraitBadgeProps): JSX.Element {
    return (
        <span className={classnames(styles.crucibleTraitBadge, TONE_CLASSES[trait.tone], className)}>
            <Icon
                icon={trait.icon}
                size="large"
                className={styles.icon}
                tooltip={hasTooltip ? `${trait.label}: ${trait.description}` : undefined}
                aria-hidden={!hasTooltip}
            />
            {trait.count !== undefined && (
                <span className={styles.count} aria-hidden="true">{trait.count}</span>
            )}
        </span>
    );
}
